export const backendBaseUrl = "https://remidio-proxy-production.appspot.com";
export const apiToken =
  "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI5MjlmMTY4ZC0zMDY3LTQwMmMtOTIwZi1mODY4ODRkZWM0N2YiLCJpc3MiOiJodHRwczovL3JlbWlkaW8tYmFja2VuZC1zdGFnaW5nLmFwcHNwb3QuY29tIiwic3ViIjoiV0VCX0RBU0hCT0FSRCJ9.Qcdzm4osHpeWdjw5m4kIE3N1xVReeE4nNhRGiNtkC9o";
export const remidioOrgIDs = [5634161670881280, 5634161670881280];
